// InterceptorInitializer.tsx
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom"; 
import { setupInterceptor } from "./authInterceptor";

const InterceptorInitializer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setupInterceptor(dispatch, navigate);
  }, [dispatch, navigate]);

  return null; // Nothing to render
};

export default InterceptorInitializer;
